import { SimpleDTO } from "@/application/dto/SimpleDTO";
import { IHttpClient } from "@/application/ports/IHttpClient";
import { Simple } from "@/domain/entities/simple";
import { API_ENDPOINTS } from "../config/api.config";
import { ISimpleRepository } from "@/domain/repositories/ISimpleRepository";

export class SimpleRepository
implements ISimpleRepository {

  constructor(
    private readonly httpClient: IHttpClient
  ) {}
    
    findById(_id: string): Promise<Simple | null> {
        throw new Error("Method not implemented.");
    }
    async create(
      table: string,
      data: Omit<Simple, "id">
    ): Promise<Simple> {

      const response = await this.httpClient.post<Simple>(
        API_ENDPOINTS.simple.base(table),
        data
      );

      return response.data as Simple;
    }
    update(_table: string, _id: string, _simple: Partial<Simple>): Promise<Simple> {
        throw new Error("Method not implemented.");
    }
    async delete(table: string, id: string): Promise<void> {
        await this.httpClient.delete<Simple>(
        API_ENDPOINTS.simple.byId(table,id),
      );

    }

  

  async findAll(
    table: string
  ): Promise<Simple[]> {

    const response =
      await this.httpClient.get<
        SimpleDTO[]
      >(
        API_ENDPOINTS.simple.base(table)
      );
      console.log(response);

    return response.data.map(dto =>
      this.mapToEntity(dto)
    );
  }

  private mapToEntity(
    dto: SimpleDTO
  ): Simple {

    return {
      id: dto.id,
      nombre: dto.nombre,
      apellido: dto.apellido,
      id_grupo: dto.id_grupo,
      cantidad: dto.cantidad
    };
  }
}
